// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* A widget reference drawn as a chip inside Monaco (#662), the way its tag is
   drawn above the editor: a rounded box with the widget's name. Global on
   purpose: Monaco applies decoration class names to its own spans. Scoped
   under .view-line so these win over Monaco's token colours. The decorations
   are in referenceChips.ts. */

/* The brackets around the name: kept in the code, not drawn. */
.monaco-editor .view-line .curio-widget-ref-hidden {
  font-size: 0;
}

.monaco-editor .view-line .curio-widget-ref,
.monaco-editor .view-line .curio-widget-ref-problem {
  border-style: solid none;
  border-width: 1px 0;
  font-weight: 500;
}

.monaco-editor .view-line .curio-widget-ref {
  background: var(--curio-accent-sky-bg);
  border-color: #b6cbf2;
  color: var(--curio-accent-sky-fg);
}

.monaco-editor .view-line .curio-widget-ref-problem {
  background: var(--curio-danger-bg);
  border-color: var(--curio-danger-border);
  color: var(--curio-danger-text);
}

/* The box's ends, on its first and last character, so the box is one box
   however many spans Monaco splits its text into. */
.monaco-editor .view-line .curio-widget-ref-first {
  border-left-style: solid;
  border-left-width: 1px;
  border-top-left-radius: var(--curio-radius-sm);
  border-bottom-left-radius: var(--curio-radius-sm);
  padding-left: 4px;
}

.monaco-editor .view-line .curio-widget-ref-last {
  border-right-style: solid;
  border-right-width: 1px;
  border-top-right-radius: var(--curio-radius-sm);
  border-bottom-right-radius: var(--curio-radius-sm);
  padding-right: 4px;
}

/* An input or column reference: the same box, green, so it reads apart from a
   widget's. A problem stays red whatever its kind. */
.monaco-editor .view-line .curio-widget-ref.curio-input-ref {
  background: var(--curio-accent-mint-bg);
  border-color: #a8d5b1;
  color: var(--curio-accent-mint-fg);
}

/* A shared reference, to a Parameter node's widget: the same box, amber. */
.monaco-editor .view-line .curio-widget-ref.curio-shared-ref {
  background: var(--curio-accent-amber-bg);
  border-color: #e8c99a;
  color: var(--curio-accent-amber-fg);
}

/* A selection reference, to the ids a view's selection picks: the same box,
   peach. */
.monaco-editor .view-line .curio-widget-ref.curio-selection-ref {
  background: var(--curio-accent-peach-bg);
  border-color: #f2b9a3;
  color: #b8461d;
}

/* A scenario chip, the colors or names of the scenarios a spec draws: the same
   box, lilac. A field of inputs is drawn as a column is, in green. */
.monaco-editor .view-line .curio-widget-ref.curio-scenario-ref {
  background: var(--curio-accent-lilac-bg);
  border-color: #cdbff0;
  color: var(--curio-accent-lilac-fg);
}
`, "",{"version":3,"sources":["webpack://./src/components/editing/widgets/widgetReferences.css"],"names":[],"mappings":"AAAA;;;;8BAI8B;;AAE9B,+DAA+D;AAC/D;EACE,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;oDACoD;AACpD;EACE,wBAAwB;EACxB,sBAAsB;EACtB,8CAA8C;EAC9C,iDAAiD;EACjD,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,+CAA+C;EAC/C,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;qDACqD;AACrD;EACE,uCAAuC;EACvC,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA,2EAA2E;AAC3E;EACE,wCAAwC;EACxC,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;WACW;AACX;EACE,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;qEACqE;AACrE;EACE,wCAAwC;EACxC,qBAAqB;EACrB,mCAAmC;AACrC","sourcesContent":["/* A widget reference drawn as a chip inside Monaco (#662), the way its tag is\n   drawn above the editor: a rounded box with the widget's name. Global on\n   purpose: Monaco applies decoration class names to its own spans. Scoped\n   under .view-line so these win over Monaco's token colours. The decorations\n   are in referenceChips.ts. */\n\n/* The brackets around the name: kept in the code, not drawn. */\n.monaco-editor .view-line .curio-widget-ref-hidden {\n  font-size: 0;\n}\n\n.monaco-editor .view-line .curio-widget-ref,\n.monaco-editor .view-line .curio-widget-ref-problem {\n  border-style: solid none;\n  border-width: 1px 0;\n  font-weight: 500;\n}\n\n.monaco-editor .view-line .curio-widget-ref {\n  background: var(--curio-accent-sky-bg);\n  border-color: #b6cbf2;\n  color: var(--curio-accent-sky-fg);\n}\n\n.monaco-editor .view-line .curio-widget-ref-problem {\n  background: var(--curio-danger-bg);\n  border-color: var(--curio-danger-border);\n  color: var(--curio-danger-text);\n}\n\n/* The box's ends, on its first and last character, so the box is one box\n   however many spans Monaco splits its text into. */\n.monaco-editor .view-line .curio-widget-ref-first {\n  border-left-style: solid;\n  border-left-width: 1px;\n  border-top-left-radius: var(--curio-radius-sm);\n  border-bottom-left-radius: var(--curio-radius-sm);\n  padding-left: 4px;\n}\n\n.monaco-editor .view-line .curio-widget-ref-last {\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-top-right-radius: var(--curio-radius-sm);\n  border-bottom-right-radius: var(--curio-radius-sm);\n  padding-right: 4px;\n}\n\n/* An input or column reference: the same box, green, so it reads apart from a\n   widget's. A problem stays red whatever its kind. */\n.monaco-editor .view-line .curio-widget-ref.curio-input-ref {\n  background: var(--curio-accent-mint-bg);\n  border-color: #a8d5b1;\n  color: var(--curio-accent-mint-fg);\n}\n\n/* A shared reference, to a Parameter node's widget: the same box, amber. */\n.monaco-editor .view-line .curio-widget-ref.curio-shared-ref {\n  background: var(--curio-accent-amber-bg);\n  border-color: #e8c99a;\n  color: var(--curio-accent-amber-fg);\n}\n\n/* A selection reference, to the ids a view's selection picks: the same box,\n   peach. */\n.monaco-editor .view-line .curio-widget-ref.curio-selection-ref {\n  background: var(--curio-accent-peach-bg);\n  border-color: #f2b9a3;\n  color: #b8461d;\n}\n\n/* A scenario chip, the colors or names of the scenarios a spec draws: the same\n   box, lilac. A field of inputs is drawn as a column is, in green. */\n.monaco-editor .view-line .curio-widget-ref.curio-scenario-ref {\n  background: var(--curio-accent-lilac-bg);\n  border-color: #cdbff0;\n  color: var(--curio-accent-lilac-fg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
